import { useSelector } from 'react-redux';
import { organisationByIdSelector, workspaceByIdSelector } from '@futrli/shared-services';
import { StoreState } from '../core/types';
import { useParams } from 'react-router-dom';

export const useTrialBanner = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';
  const organisation = useSelector((store: StoreState) =>
    organisationByIdSelector(store.normalised, workspaceId, organisationId)
  );
  const workspace = useSelector((store: StoreState) => workspaceByIdSelector(store.normalised, workspaceId));

  const hasTrialBanner =
    workspace?.subscription_state === 'trial' &&
    ['chargebee', 'not_billed'].includes(organisation?.billed_by as string);

  return { hasTrialBanner };
};
